module.exports = __webpack_public_path__ + "img/slide10.27f477b0.png";